import {type UIChild, UI} from "../../../stem-core/ui/UIBase";
import {TextInput} from "../../../stem-core/ui/input/Input";
import {Button} from "../../../stem-core/ui/button/Button";
import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {DashboardBaseInput} from "../../../core/ui/input/BaseInput.js";
import {CloseIcon} from "../../../core/ui/SVGElements.jsx";


class ArrayInputStyle extends StyleSheet {
    @styleRule
    elementInputContainer = {
        position: "relative",
        display: "flex",
        paddingRight: 16,
        marginBottom: 8,
    };

    @styleRule
    elementInputContainerBox = {
        background: this.themeProps.MERCHANT_CARD_BACKGROUND,
        padding: "18px 24px 18px 24px",
        border: "1px solid " + this.themeProps.MERCHANT_CARD_BORDER_COLOR,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
    };

    @styleRule
    deleteButtonContainer = {
        width: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    @styleRule
    deleteButton = {
        cursor: "pointer",
    };

    @styleRule
    deleteButtonBox = {
        position: "absolute",
        top: 12,
        right: 12,
    };
}


interface ArrayInputOptions {
    // The element class each entry is edited with, plus the options forwarded to it
    ElementInputClass?: any;
    elementInputOptions?: Record<string, any>;
    addButtonLabel?: UIChild;
    box?: boolean;
    enableAdd?: boolean;
    enableDelete?: boolean;
}

@registerStyle(ArrayInputStyle)
export class ArrayInput<ExtraOptions = {}> extends DashboardBaseInput<ArrayInputOptions & ExtraOptions> {
    getDefaultOptions(options?: any): Record<string, any> | undefined;
    getDefaultOptions(): Record<string, any> | undefined {
        return {
            ...super.getDefaultOptions(),
            ElementInputClass: TextInput,
            elementInputOptions: {},
            box: true,
            enableDelete: true,
            enableAdd: true,
            addButtonLabel: "Add",
            initialValue: [],
        };
    }

    renderElementInput(index: number, elementValue: unknown) {
        const {styleSheet} = this;
        const {ElementInputClass, enableDelete, box} = this.options;
        const update = () => {
            this.value[index] = this[`elementInput-${index}`].getValue();
            this.setAndDispatchValue(this.getValue());
        }
        return <div className={styleSheet.elementInputContainer + (box ? styleSheet.elementInputContainerBox : "")}>
            <div style={{flex: 1}}>
                <ElementInputClass
                    ref={this.refLink(`elementInput-${index}`)}
                    initialValue={elementValue}
                    onChange={update}
                    {...this.options.elementInputOptions}
                />
            </div>
            {enableDelete && <div className={styleSheet.deleteButtonContainer}>
                <CloseIcon className={styleSheet.deleteButton + (box ? styleSheet.deleteButtonBox : "")}
                           onClick={() => {
                                 this.value.splice(index, 1);
                                 this.setAndDispatchValue(this.value);
                             }}/>
            </div>}
        </div>;
    }

    addElement() {
        this.value.push(this.options.ElementInputClass.defaultValue);
        this.redraw();
        this.setAndDispatchValue(this.value);
    }

    renderAddButton(): UIChild {
        return <Button onClick={() => this.addElement()} style={{marginLeft: 0}}>
            {this.options.addButtonLabel}
        </Button>;
    }

    render() {
        return [
            this.value.map((elementValue: unknown, index: number) => this.renderElementInput(index, elementValue)),
            this.options.enableAdd && this.renderAddButton(),
        ];
    }
}
